let timer;

export default{
    async login(context, payload){
        return context.dispatch('auth', {
            ...payload,
            mode: 'login'
        });
    },
    async signup(context, payload){
        return context.dispatch('auth', {
            ...payload,
            mode: 'signup'
        });
    },
    async auth(context, payload){
        const mode = payload.mode;
        // URL for Login
        let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBva-nq7TKalzMdm3gYTh1_yUoT8fazDjo';

        // If user clicks on signup mode, the url changes to sign up
        if(mode === 'signup'){
            url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBva-nq7TKalzMdm3gYTh1_yUoT8fazDjo';
        }

        const response = await fetch(url,
        {
            method: 'POST',
            body: JSON.stringify({
                email: payload.email,
                password: payload.password,
                returnSecureToken: true
            })
        });

        const responseData = await response.json();
        if(!response.ok){
            const error = new Error(responseData.message || 'Failed to login');
            throw error;
        }

        // Set Expiration Limit
        const expiresIn = +responseData.expiresIn * 1000;
        const expirationDate = new Date().getTime() + expiresIn;

        // Local Storage is a Library - helps keep the user logged in
        localStorage.setItem('token', responseData.idToken);
        localStorage.setItem('userId', responseData.userId);
        localStorage.setItem('tokenExpiration', expirationDate);

        // Timer Function to Set User to Logout
        timer = setTimeout(function(){
            context.dispatch('autoLogout');
        }, expiresIn);

        context.commit('setUser', {
            token: responseData.idToken,
            userId: responseData.localId,
        });
    },
    autoLogin(context){
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        const tokenExpiration = localStorage.getItem('tokenExpiration');

        // Compares the token expiration
        const expiresIn = +tokenExpiration - new Date().getTime();

        if(expiresIn < 0){
            return;
        }

        timer = setTimeout(function(){
            context.dispatch('autoLogout');
        }, expiresIn);

        if(token && userId){
            context.commit('setUser', {
                token: token,
                userId: userId,
            });
        }
    },
    logout(context){
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('tokenExpiration');

        // Clear the timer
        clearTimeout(timer);

        // Reset Token, UserId, and TokenExpiration
        context.commit('setUser',{
            token: null,
            userId: null,
        });
    },
    autoLogout(context){
        context.dispatch('logout');
        context.commit('setAutoLogout');
    }   
};